import React from 'react';
import { SweepstakesFullComponent } from '@thd-olt-component-react/loyalty-benefits';
import { RewardsHubContext } from '../../../../contexts';
var RenderSweepstakesComponent = function () {
    return (React.createElement("div", { "data-testid": "sweepstakes-card-RH", className: "sui-mb-6 sm:sui-mb-12" },
        React.createElement(SweepstakesFullComponent, { useRestAPI: true, showHeaders: true })));
};
export var SweepstakesCard = function () {
    var isSweepstakesEnabled = React.useContext(RewardsHubContext).isSweepstakesEnabled;
    return isSweepstakesEnabled ? React.createElement(RenderSweepstakesComponent, null) : React.createElement(React.Fragment, null);
};
